export const tabNames = {
  PARTY: "party",
  SEARCH: "search",
  SETTINGS: "menu",
};

export const PLAYBACK_TIMEOUT_S = 20;
export const NEXT_TRACK_COUNTDOWN_LIMIT_S = 20;
